/**
 * 관리자 사용자 관리 (M12) API wrapper.
 *
 * 백엔드 엔드포인트:
 *   GET    /api/admin/users
 *   POST   /api/admin/users
 *   PATCH  /api/admin/users/{user_id}
 *   POST   /api/admin/users/{user_id}/reset-password
 *
 * 모든 엔드포인트는 ``require_admin`` 가드. 일반 사용자가 호출하면 403.
 */

import { apiClient } from "./client";

export type UserRole = "admin" | "user";

export interface AdminUserOut {
  id: number;
  email: string;
  role: UserRole;
  is_active: boolean;
  must_change_password: boolean;
  created_at: string;
  updated_at: string;
}

export interface AdminUserCreatePayload {
  email: string;
  password: string;
  role?: UserRole;
}

export interface AdminUserPatchPayload {
  role?: UserRole;
  is_active?: boolean;
}

export async function listAdminUsers(): Promise<AdminUserOut[]> {
  const res = await apiClient.get<AdminUserOut[]>("/admin/users");
  return res.data;
}

export async function createAdminUser(payload: AdminUserCreatePayload): Promise<AdminUserOut> {
  const res = await apiClient.post<AdminUserOut>("/admin/users", payload);
  return res.data;
}

export async function updateAdminUser(
  userId: number,
  payload: AdminUserPatchPayload,
): Promise<AdminUserOut> {
  const res = await apiClient.patch<AdminUserOut>(`/admin/users/${userId}`, payload);
  return res.data;
}

export async function resetAdminUserPassword(
  userId: number,
  newPassword: string,
): Promise<AdminUserOut> {
  const res = await apiClient.post<AdminUserOut>(`/admin/users/${userId}/reset-password`, {
    new_password: newPassword,
  });
  return res.data;
}
